var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn btn-outline-primary text-center rounded-pill pa-0",attrs:{"icon":""},on:{"click":function($event){return _vm.click(_vm.data)}}},[_c('i',{staticClass:"fa fa-crosshairs ma-0 pa-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }